import {map} from 'rxjs/operators';
import {dialogOpen$} from './private/internal-dialog-actions';

export const dialogChanged$ = dialogOpen$.pipe(
    map(() => undefined),
);
